export default __webpack_public_path__ + "static/media/logo-dark.606079e5.svg";